/* Cedarfur PDP — extracted from local-preview/pdp.html on 2026-05-26 for Shopify theme deployment */

(function () {
  'use strict';

  /* ================================================================
     GALLERY THUMB CLICK — swaps hero image on thumb click.
     Preserves active state on the clicked thumb.
  ================================================================ */
  (function galleryThumbHandler() {
    function init() {
      var thumbs = document.querySelectorAll('[data-cf-thumb-src]');
      var hero = document.getElementById('cf-hero-img');
      if (!hero) return;
      for (var i = 0; i < thumbs.length; i++) {
        (function (thumb) {
          thumb.addEventListener('click', function () {
            var src = thumb.getAttribute('data-cf-thumb-src');
            if (src) hero.src = src;
            // Update active state
            for (var j = 0; j < thumbs.length; j++) {
              thumbs[j].classList.toggle('gallery__thumb--active', thumbs[j] === thumb);
            }
          });
        })(thumbs[i]);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
  })();

  /* ================================================================
     GALLERY SWIPE (touch / mobile) — swipe the main image left/right
     to advance through the gallery. Reuses the dot click handler so the
     hero swaps and the active dot stays in sync. Wraps around at the ends.
     Horizontal-only: ignores vertical scroll gestures.
  ================================================================ */
  (function gallerySwipeHandler() {
    function init() {
      var main = document.querySelector('.gallery__main');
      if (!main) return;
      var x0 = null, y0 = null;
      main.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        x0 = t.clientX; y0 = t.clientY;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0, dy = t.clientY - y0;
        x0 = null; y0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return; // need a clear horizontal swipe
        var dots = document.querySelectorAll('[data-cf-thumb-src]');
        if (dots.length < 2) return;
        var activeIdx = 0;
        for (var i = 0; i < dots.length; i++) {
          if (dots[i].classList.contains('gallery__thumb--active')) { activeIdx = i; break; }
        }
        var nextIdx = dx < 0 ? activeIdx + 1 : activeIdx - 1; // swipe left -> next image
        if (nextIdx < 0) nextIdx = dots.length - 1;
        if (nextIdx >= dots.length) nextIdx = 0;
        dots[nextIdx].click();
      }, { passive: true });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
  })();

  /* ================================================================
     VARIANT PICKER — color swatches swap hero image + readout label.

     Shopify form wiring:
     - On swatch click, reads data-variant-id from the swatch button.
     - Sets the hidden form input #cf-product-form (name="id") to
       that variant ID so the native Shopify add-to-cart form submits
       the correct variant.
     - If data-variant-id is absent (local preview / fallback mode),
       the form is left untouched — graceful no-op.

     Swatch + composite asset URLs resolved at theme-render time via Liquid
     (this file is .js.liquid so Shopify processes the  tags).
  ================================================================ */
  (function variantPickerHandler() {
    // 'black' and 'charcoal' both map to the same dark-grey artwork. The current
    // product (rebuilt 2026-05-28 after HyperSKU re-install) labels this variant
    // 'Black'; the prior naming was 'Charcoal'. Both work — alias maintained.
    var COLORS = ['green', 'pink', 'red', 'charcoal', 'black', 'grey', 'blue'];

    var SWATCH_BY_COLOR = {
      green:    '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-swatch-green.jpg?v=42976925537480313151781216299',
      pink:     '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-swatch-pink.jpg?v=74098425242466313551781216299',
      red:      '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-swatch-red.jpg?v=36833608443134369191781216298',
      charcoal: '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-swatch-charcoal.jpg?v=80563104856219593811781216299',
      black:    '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-swatch-black.jpg?v=31421669344106670871781216299',
      grey:     '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-swatch-grey.jpg?v=28598807826710572121781216299',
      blue:     '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-swatch-blue.jpg?v=53037441070358265031781216299'
    };

    var COMPOSITE_BY_COLOR = {
      green:    '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-hero.png?v=24143565756845934981781216298',
      pink:     '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-variant-pink.jpg?v=57682850027292177701781216298',
      red:      '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-variant-red.jpg?v=62497744435493642721781216298',
      charcoal: '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-variant-charcoal.jpg?v=136622758742541085661781216298',
      black:    '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-variant-black.jpg?v=179411302664111249211781216298',
      grey:     '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-variant-grey.jpg?v=88027619565383447781781216298',
      blue:     '//cedarfur.com/cdn/shop/t/24/assets/cedarfur-variant-blue.jpg?v=48846794787004205101781216298'
    };

    function swatchPath(color) { return SWATCH_BY_COLOR[color] || null; }
    function compositePath(color) { return COMPOSITE_BY_COLOR[color] || null; }

    function preloadAndSetBackground(swatch, url) {
      var probe = new Image();
      probe.onload = function () { swatch.style.backgroundImage = "url('" + url + "')"; };
      probe.onerror = function () { /* leave solid color fill */ };
      probe.src = url;
    }

    function initSwatchBackgrounds(root) {
      var opts = root.querySelectorAll('[data-cf-color]');
      for (var i = 0; i < opts.length; i++) {
        preloadAndSetBackground(opts[i], swatchPath(opts[i].getAttribute('data-cf-color')));
      }
    }

    function swapHero(color) {
      var img = document.getElementById('cf-hero-img');
      if (!img) return;
      var url = compositePath(color);
      if (!url) return;
      var probe = new Image();
      probe.onload = function () { img.src = url; };
      probe.onerror = function () {
        try { /* console.warn('[Cedarfur picker] Composite missing at ' + url); */ } catch (e) {}
      };
      probe.src = url;
    }

    function setActive(root, color) {
      var opts = root.querySelectorAll('[data-cf-color]');
      for (var i = 0; i < opts.length; i++) {
        var isActive = opts[i].getAttribute('data-cf-color') === color;
        opts[i].classList.toggle('vpicker__opt--active', isActive);
        opts[i].setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
      var readout = root.querySelector('[data-cf-color-readout]');
      if (readout) readout.textContent = color.charAt(0).toUpperCase() + color.slice(1);
    }

    // Resolve the bundle variant matching the CURRENT tier + color and
    // write its ID into the form. This is the single point where
    // (tier, color) → variant lookup happens — both the color picker
    // and the bundle-tier handler call it.
    function currentTier() {
      var t = document.querySelector('input[name="cf-bundle-tier"]:checked');
      return (t && t.value) || '2pack';
    }

    function setBundleVariant(color) {
      var tier = currentTier();
      var bundle = window.cfBundles && window.cfBundles[tier];
      if (!bundle || !Array.isArray(bundle.variants)) return;
      var normalized = String(color || '').toLowerCase().trim();
      var match = bundle.variants.find(function (v) {
        var opt = (v.option1 || v.title || '').toLowerCase().trim();
        return opt === normalized;
      });
      if (!match) {
        match = bundle.variants.find(function (v) { return v.available; }) || bundle.variants[0];
      }
      if (!match) return;
      var variantInput = document.getElementById('cf-variant-id');
      if (variantInput) variantInput.value = match.id;
      // Warm the browser cache for this variant's drawer thumbnail NOW, while
      // the user is still choosing. By the time they hit Add to Cart the image
      // is decoded, so the drawer line paints instantly instead of flashing a
      // blank thumbnail (naturalWidth 0) for ~100-300ms on first open.
      if (match.featured_image && match.featured_image.src) {
        var warm = new Image();
        warm.src = match.featured_image.src;
      }
      // Keep window.cfProduct in sync with the currently-selected bundle
      // so optimistic open uses the right title + image + price.
      window.cfProduct = bundle;
      // Optional: update visible price if a price element exists
      var priceEl = document.querySelector('[data-cf-price-display]');
      if (priceEl && match.price != null) {
        priceEl.textContent = '$' + (match.price / 100).toFixed(2);
      }
    }

    // Update all three bundle card images to the given color.
    // Reads URLs from window.cfBundleImages which is rendered by Liquid in the section.
    function updateBundleImages(color) {
      var map = window.cfBundleImages;
      if (!map) return;
      var normalized = String(color || 'green').toLowerCase().trim();
      var imgs = document.querySelectorAll('[data-cf-bundle-img]');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        var tier = img.getAttribute('data-cf-bundle-img');
        var tierMap = map[tier];
        if (!tierMap) continue;
        var url = tierMap[normalized] || tierMap['green'];
        if (url && img.src !== url) {
          img.src = url;
        }
      }
    }

    // Public alias used by the color picker and the bundle-tier handler.
    function wireVariantId(target, color) {
      if (color) { setBundleVariant(color); updateBundleImages(color); return; }
      var variantId = target && target.getAttribute('data-variant-id');
      if (!variantId) return;
      var variantInput = document.getElementById('cf-variant-id');
      if (variantInput) variantInput.value = variantId;
    }

    // Expose for the bundle-tier handler (separate IIFE).
    // Also refreshes bundle card images so the right tier×color combo shows.
    window.cfReResolveVariant = function () {
      var active = document.querySelector('#cf-color-picker .vpicker__opt--active[data-cf-color]') ||
                   document.querySelector('#cf-color-picker [data-cf-color="green"]');
      var color = active && active.getAttribute('data-cf-color');
      if (color) {
        setBundleVariant(color);
        updateBundleImages(color);
      }
    };

    function init() {
      var root = document.getElementById('cf-color-picker');
      if (!root) return;
      initSwatchBackgrounds(root);

      // Hydrate initial state: set variant for the default active swatch (green)
      var activeOnLoad = root.querySelector('.vpicker__opt--active[data-cf-color]') ||
                         root.querySelector('[data-cf-color="green"]');
      if (activeOnLoad) {
        var defaultColor = activeOnLoad.getAttribute('data-cf-color') || 'green';
        if (defaultColor) {
          setActive(root, 'green');
          swapHero('green');
          wireVariantId(activeOnLoad, 'green');
        }
      }

      root.addEventListener('click', function (e) {
        var target = e.target.closest('[data-cf-color]');
        if (!target || !root.contains(target)) return;
        var color = target.getAttribute('data-cf-color');
        if (!color || COLORS.indexOf(color) === -1) return;
        setActive(root, color);
        swapHero(color);
        // Wire Shopify form variant ID — uses cfProduct fuzzy match, falls back to data-variant-id
        wireVariantId(target, color);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
  })();

  /* ================================================================
     QTY STEPPER — + / − buttons update the visible qty input and the
     hidden form quantity input (#cf-qty-input) in lockstep so the
     submitted quantity matches what the user sees.
  ================================================================ */
  (function qtyStepperHandler() {
    function clampQty(val, min, max) {
      val = parseInt(val, 10);
      if (isNaN(val) || val < min) return min;
      if (val > max) return max;
      return val;
    }

    function syncHiddenQty(displayVal) {
      var hidden = document.getElementById('cf-qty-input');
      if (hidden) hidden.value = displayVal;
    }

    function init() {
      var qtyRows = document.querySelectorAll('.qty');
      for (var i = 0; i < qtyRows.length; i++) {
        (function (qtyRow) {
          var decreaseBtn = qtyRow.querySelector('[aria-label="Decrease quantity"]');
          var increaseBtn = qtyRow.querySelector('[aria-label="Increase quantity"]');
          var displayInput = qtyRow.querySelector('input[aria-label="Quantity"]');
          if (!decreaseBtn || !increaseBtn || !displayInput) return;

          function getVal() { return parseInt(displayInput.value, 10) || 1; }
          function setVal(v) {
            var clamped = clampQty(v, 1, 99);
            displayInput.value = clamped;
            syncHiddenQty(clamped);
          }

          decreaseBtn.addEventListener('click', function () { setVal(getVal() - 1); });
          increaseBtn.addEventListener('click', function () { setVal(getVal() + 1); });

          // Keep hidden input in sync if user types directly into the display field
          displayInput.addEventListener('change', function () { setVal(getVal()); });
          displayInput.addEventListener('blur',   function () { setVal(getVal()); });
        })(qtyRows[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
  })();

  /* ================================================================
     BUNDLE PICKER:
     Native theme handler. Pricing + quantity + discount logic is handled
     entirely in this theme + Shopify automatic discounts (no external app).

     This handler:
     - Reads ?tier= or ?ref=adv-...&tier= URL params on page load.
     - Pre-selects the matching radio. Defaults to 2pack.
     - ALLOWED_TIERS: 1pack | 2pack | 3pack
     - LEGACY FALLTHROUGH: ?tier=4pack silently resolves to 2pack (default)
       so any inbound links using the old 4-pack URL still land cleanly.
  ================================================================ */
  (function bundlePickerHandler() {
    var ALLOWED_TIERS = ['1pack', '2pack', '3pack'];
    var BUNDLE_ID = 'cf-hero-bundle-main-pdp-hero';

    function getRequestedTier() {
      try {
        var params = new URLSearchParams(window.location.search);
        var tier = params.get('tier');
        // Legacy 4pack links fall through to default (2pack)
        if (tier === '4pack') return null;
        if (tier && ALLOWED_TIERS.indexOf(tier) !== -1) return tier;
      } catch (e) {}
      return null;
    }

    function resolveTier(root) {
      var requested = getRequestedTier();
      if (requested) return requested;
      var fallback = root && root.getAttribute('data-cf-default-tier');
      if (fallback && ALLOWED_TIERS.indexOf(fallback) !== -1) return fallback;
      return '2pack';
    }

    function preselect(root, tier) {
      if (!root) return false;
      var input = root.querySelector('input[data-cf-tier-input="' + tier + '"]');
      if (!input) return false;
      if (input.checked) return true;
      input.checked = true;
      try { input.dispatchEvent(new Event('change', { bubbles: true })); }
      catch (e) {
        var evt = document.createEvent('HTMLEvents');
        evt.initEvent('change', true, false);
        input.dispatchEvent(evt);
      }
      return true;
    }

    function init() {
      var root = document.getElementById(BUNDLE_ID);
      if (root) {
        var tier = resolveTier(root);
        if (preselect(root, tier)) return;
      }
      if (!('MutationObserver' in window)) return;
      var attempts = 0;
      var observer = new MutationObserver(function () {
        attempts++;
        var late = document.getElementById(BUNDLE_ID);
        if (late) {
          var t = resolveTier(late);
          if (preselect(late, t)) observer.disconnect();
        }
        if (attempts > 40) observer.disconnect();
      });
      observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { try { observer.disconnect(); } catch (e) {} }, 2000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
  })();

  /* ================================================================
     BUNDLE TIER HANDLER — wires .bundle__tier [data-quantity] clicks
     to the hidden #cf-quantity form input.

     Works alongside bundlePickerHandler (which handles radio pre-selection
     and URL param tier routing). This handler owns the quantity sync path:
     - On init: reads the default-checked tier and sets #cf-quantity.
       Default is Buy 2 (quantity 2) unless a different tier is checked.
     - On click/change: updates #cf-quantity to match data-quantity value.
     - Also updates [data-cf-qty-display] if present (visible qty readout).
  ================================================================ */
  (function bundleTierHandler() {
    // Quantity is now always 1 — each tier IS its own bundle product.
    function setQuantity(qty) {
      var qtyInput = document.getElementById('cf-quantity');
      if (qtyInput) qtyInput.value = String(qty);
      var qtyDisplay = document.querySelector('[data-cf-qty-display]');
      if (qtyDisplay) qtyDisplay.value = String(qty);
    }

    function syncVariant() {
      // Variant ID is (currentTier, currentColor) → cfBundles lookup.
      // Delegate to the color picker's resolver so the form gets the
      // right bundle variant for the new tier + already-selected color.
      if (typeof window.cfReResolveVariant === 'function') {
        window.cfReResolveVariant();
      }
    }

    function init() {
      var tiers = document.querySelectorAll('.bundle__tier');
      if (!tiers.length) return;

      // Bundles are one-per-line in cart; submit qty=1 always.
      setQuantity(1);
      syncVariant();

      tiers.forEach(function (tier) {
        tier.addEventListener('change', function () {
          setQuantity(1);
          syncVariant();
        });
        tier.addEventListener('click', function () {
          setQuantity(1);
          syncVariant();
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  /* ================================================================
     PRODUCT FORM HANDLER — Shopify Bundles refactor (2026-05-29).

     The user picks (tier + color); window.cfBundles + variantPicker
     resolve that to a single bundle-product variant ID and write it
     into #cf-variant-id. On submit:

       1. Optimistic drawer open in <100ms with a synthetic line built
          from the selected cfBundles entry (uses the bundle product's
          first image and price for the line — bundle gifts are baked
          into the product itself, no separate add).
       2. ONE /cart/add.js POST for that single bundle variant.
       3. /cart.js refresh + renderDrawer with truth-of-record.

     No gift lookups, no batched payload, no race guards. Each bundle
     is one product = one cart line.
  ================================================================ */
  (function productFormHandler() {
    var isSubmitting = false;

    function currentTier() {
      var t = document.querySelector('input[name="cf-bundle-tier"]:checked');
      return (t && t.value) || '2pack';
    }

    function buildOptimisticCart(variantId) {
      if (!window.cfCart || typeof window.cfCart.getLastCart !== 'function') return null;
      var base = window.cfCart.getLastCart() || { items: [], item_count: 0, total_price: 0, items_subtotal_price: 0 };
      var next;
      try { next = JSON.parse(JSON.stringify(base)); }
      catch (e) { return null; }
      next.items = (next.items || []).filter(function (i) {
        return !(i.key && i.key.indexOf('optimistic-') === 0);
      });

      // Resolve the bundle + variant by the ACTUAL variantId across ALL bundles,
      // not by the currently-checked tier. If the tier radio and the resolved
      // variant ever disagree (rapid tier/color/sticky changes), the old code
      // fell back to bundle.variants[0] (= Blue) and the drawer flashed a product
      // the user never picked. Search by id and, on no match, skip the optimistic
      // line entirely so we never render a guessed/wrong item.
      var bundle = null, variant = null;
      if (window.cfBundles) {
        var keys = Object.keys(window.cfBundles);
        for (var ki = 0; ki < keys.length; ki++) {
          var bd = window.cfBundles[keys[ki]];
          if (!bd || !Array.isArray(bd.variants)) continue;
          for (var vi = 0; vi < bd.variants.length; vi++) {
            if (String(bd.variants[vi].id) === String(variantId)) { bundle = bd; variant = bd.variants[vi]; break; }
          }
          if (variant) break;
        }
      }
      if (!bundle || !variant) return null;
      var hero = document.getElementById('cf-hero-img');
      var heroSrc = (variant && variant.featured_image && variant.featured_image.src) ||
                    (bundle.featured_image) ||
                    (hero ? hero.src : '');
      var price = (variant && variant.price) || bundle.price || 0;
      var line = {
        key: 'optimistic-bundle-' + variantId,
        id: parseInt(variantId, 10),
        variant_id: parseInt(variantId, 10),
        handle: bundle.handle,
        product_handle: bundle.handle,
        url: '/products/' + bundle.handle,
        quantity: 1,
        title: bundle.title + (variant && variant.title && variant.title !== 'Default Title' ? ' - ' + variant.title : ''),
        product_title: bundle.title,
        variant_title: variant && variant.title !== 'Default Title' ? variant.title : '',
        image: heroSrc,
        price: price,
        original_price: price,
        line_price: price,
        original_line_price: price,
        final_line_price: price,
        properties: {}
      };
      next.items.push(line);
      var totalPrice = 0, itemCount = 0;
      next.items.forEach(function (i) {
        totalPrice += (i.final_line_price != null) ? i.final_line_price : (i.line_price || 0);
        itemCount += (i.quantity || 0);
      });
      next.total_price = totalPrice;
      next.items_subtotal_price = totalPrice;
      next.item_count = itemCount;
      return next;
    }

    function openDrawerWith(cart) {
      if (window.cfCart && typeof window.cfCart.renderDrawer === 'function') {
        try { window.cfCart.renderDrawer(cart); } catch (e) {}
      }
      if (window.cfCartDrawer && typeof window.cfCartDrawer.open === 'function') {
        try { window.cfCartDrawer.open(); } catch (e2) {}
      }
    }

    function init() {
      var form = document.getElementById('cf-product-form');
      if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (isSubmitting) return;
        isSubmitting = true;

        var variantInput = document.getElementById('cf-variant-id');
        if (!variantInput || !variantInput.value) {
          isSubmitting = false;
          getOrCreateErrorEl(form).textContent = 'Please select a color before adding to cart.';
          return;
        }
        var variantId = variantInput.value;

        var atc = document.getElementById('cf-atc');
        var originalText = atc ? atc.textContent : '';
        if (atc) { atc.disabled = true; atc.textContent = 'Adding…'; }

        var existingErr = form.querySelector('[data-cf-cart-error]');
        if (existingErr) existingErr.textContent = '';

        // 1) Optimistic open — paints in <100ms.
        var optimisticCart = buildOptimisticCart(variantId);
        if (optimisticCart) openDrawerWith(optimisticCart);

        // 2) Single-item POST.
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        }).then(function (resp) {
          if (!resp.ok) {
            return resp.json().then(function (err) {
              throw new Error(err.description || err.message || 'Add to cart failed');
            }, function () { throw new Error('Add to cart failed: ' + resp.status); });
          }
          return resp.json();
        }).then(function () {
          // 3) Refresh authoritative cart + re-render drawer.
          if (window.cfCart && typeof window.cfCart.getCart === 'function') {
            return window.cfCart.getCart().then(function (cart) {
              if (cart && window.cfCart.renderDrawer) {
                try { window.cfCart.renderDrawer(cart); } catch (e) {}
              }
            });
          }
        }).catch(function (err) {
          var rawMsg = (err && err.message) || '';
          getOrCreateErrorEl(form).textContent = rawMsg || 'Could not add to cart. Please try again.';
          if (window.cfCart && typeof window.cfCart.showError === 'function') {
            window.cfCart.showError('We could not add that to your cart. Please refresh the page and try again.');
          }
          if (window.cfCart && typeof window.cfCart.getCart === 'function') {
            window.cfCart.getCart().then(function (cart) {
              if (cart && window.cfCart.renderDrawer) {
                try { window.cfCart.renderDrawer(cart); } catch (e) {}
              }
            }).catch(function () {});
          }
          if (!window.cfCartDrawer || typeof window.cfCartDrawer.open !== 'function') {
            window.location.href = '/cart';
          }
        }).then(reEnable, reEnable);   // run on BOTH success and failure (incl. if the catch handler itself throws) so the button never stays stuck disabled
        function reEnable() {
          isSubmitting = false;
          if (atc) { atc.disabled = false; atc.textContent = originalText; }
        }
      });
    }

    function getOrCreateErrorEl(form) {
      var el = form.querySelector('[data-cf-cart-error]');
      if (el) return el;
      el = document.createElement('p');
      el.setAttribute('data-cf-cart-error', '');
      el.style.cssText = 'color:#B91C1C; font-size:13px; margin-top:8px;';
      form.appendChild(el);
      return el;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  /* ================================================================
     GIFT UNLOCK HANDLER — listens to bundle tier radio changes and
     toggles is-unlocked / is-locked on .bx__bonus-mini__card elements
     based on their data-unlock-tier attribute vs the current tier rank.

     Ladder (locked):
       1pack (rank 1) → no cards unlocked (all cards remain is-locked)
       2pack (rank 2) → cards with data-unlock-tier="2pack" unlock
       3pack (rank 3) → all cards unlock (2pack + 3pack)
  ================================================================ */
  (function giftUnlockHandler(){
    var TIER_RANK = { '1pack': 1, '2pack': 2, '3pack': 3 };
    var radios = document.querySelectorAll('input[name="cf-bundle-tier"]');
    var cards = document.querySelectorAll('.bx__bonus-mini__card[data-unlock-tier]');
    function sync(){
      var checked = document.querySelector('input[name="cf-bundle-tier"]:checked');
      if (!checked) return;
      var currentRank = TIER_RANK[checked.value] || 1;
      cards.forEach(function(card){
        var cardRank = TIER_RANK[card.dataset.unlockTier] || 1;
        card.classList.toggle('is-unlocked', cardRank <= currentRank);
        card.classList.toggle('is-locked', cardRank > currentRank);
      });
    }
    radios.forEach(function(r){ r.addEventListener('change', sync); });
    sync(); // initial state on page load
  })();

  /* ================================================================
     SCROLL-TO-TOP FAB — shows after 600px scroll, smooth scrolls to
     top on click or Enter/Space keypress.
     Respects prefers-reduced-motion.
  ================================================================ */
  (function scrollToTopHandler() {
    var btn = document.querySelector('.cf-back-to-top');
    if (!btn) return;
    var SCROLL_THRESHOLD = 600;
    function onScroll() {
      if (window.scrollY > SCROLL_THRESHOLD) {
        btn.classList.add('cf-back-to-top--visible');
      } else {
        btn.classList.remove('cf-back-to-top--visible');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: prefersReduced ? 'auto' : 'smooth' });
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        btn.click();
      }
    });
  })();

})();
